import { FormField, FormRenderTypes } from '../Shared/Components/FormRenderer';
import { FormRenderGroupTypes } from '../Shared/Components/FormRenderer/FormRenderGroup.types';
import { BankAccount } from './Types/bankAccountTypes';

export const bankAccountFields: FormField<BankAccount>[] = [
  {
    name: 'companyId',
    label: 'Firma',
    type: FormRenderTypes.select,
    value: '',
    placeholder: 'Wybierz firmę',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'accountNumber',
    label: 'Numer konta',
    type: FormRenderTypes.input,
    value: '',
    placeholder: 'Wprowadź numer konta',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'bankName',
    label: 'Nazwa banku',
    type: FormRenderTypes.input,
    value: '',
    placeholder: 'Wprowadź nazwę banku',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'bankBranch',
    label: 'Oddział banku',
    type: FormRenderTypes.input,
    value: '',
    placeholder: 'Wprowadź oddział banku',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'swift',
    label: 'SWIFT',
    type: FormRenderTypes.input,
    value: '',
    placeholder: 'Wprowadź kod SWIFT/BIC',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'currency',
    label: 'Waluta',
    type: FormRenderTypes.input,
    value: '',
    placeholder: 'Wybierz walutę',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'description',
    label: 'Opis',
    type: FormRenderTypes.textarea,
    value: '',
    placeholder: 'Wprowadź opis konta',
    group: FormRenderGroupTypes.basic,
  },
];
